export class EventTypeModel {
  constructor(
    public id: number = null,

    public label: string = null
  ) {}
}
